import { AiStrategyTrade } from "../models/ai/ai-strategy-trade";

export class AiStrategyTradesJSONToResponseModelMapper {
    public static map(trades: any[]): AiStrategyTrade[] {
        return trades.map(t => {
            const trade = new AiStrategyTrade();
            trade.id               = t.id;
            trade.symbol           = t.symbol;
            trade.isLong           = t.isLong ?? false;
            trade.isOpen           = t.isOpen ?? false;
            trade.isNew            = t.isNew ?? false;
            trade.isNewReenter     = t.isNewReenter ?? false;
            trade.entryTime        = t.entryTime ? new Date(t.entryTime) : undefined;
            trade.entryPrice       = t.entryPrice;
            trade.exitTime         = t.exitTime ? new Date(t.exitTime) : undefined;
            trade.exitPrice        = t.exitPrice ?? undefined;
            trade.exitReason       = t.exitReason;
            trade.stopPrice        = t.stopPrice ?? undefined;
            trade.smartStop        = t.smartStop ?? undefined;
            trade.timeStop         = t.timeStop ? new Date(t.timeStop) : undefined;
            trade.lastPrice        = t.lastPrice ?? undefined;
            trade.fullRiskProfit   = t.fullRiskProfit ?? undefined;
            trade.maxProfit        = t.maxProfit ?? undefined;
            trade.maxProfitTime    = t.maxProfitTime ? new Date(t.maxProfitTime) : undefined;
            trade.minProfit        = t.minProfit ?? undefined;
            trade.minProfitTime    = t.minProfitTime ? new Date(t.minProfitTime) : undefined;
            trade.profitChange15   = t.profitChange15 ?? undefined;
            trade.profitChange5    = t.profitChange5 ?? undefined;
            trade.tradeZone        = t.tradeZone ?? 0;
            trade.reenterTime      = t.reenterTime ? new Date(t.reenterTime) : undefined;
            trade.reenterPrice     = t.reenterPrice ?? undefined;
            trade.reenterStopPrice = t.reenterStopPrice ?? undefined;
            trade.dataLastUpdated  = t.dataLastUpdated ? new Date(t.dataLastUpdated) : undefined;
            trade.segmentCode      = t.segmentCode;
            trade.segmentName      = t.segmentName;
            trade.strategyName     = t.strategyName;
            return trade;
        });
    }
}
